import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalVariable } from 'app/main/globals';

@Injectable({
  providedIn: 'root'
})
export class AspPaymentsCollectionsService {
  isAutoversePay: boolean;

  constructor(
    private http: HttpClient,
  ) { }
    pendingIvoices() {  
     const payload=  {
      "desc":true,
      "garageKey":localStorage.getItem('garageKey'),
      "status":"unpaid"
     }
      return this.http.post(`${GlobalVariable.BASE_API_URL_SPARES}` + '/zoho/v1/invoices', payload);
  
    }
    paidIvoices() {  
     const payload=  {
      "desc":true,
      "garageKey":localStorage.getItem('garageKey'),
      "status":"paid"
     }
      return this.http.post(`${GlobalVariable.BASE_API_URL_SPARES}` + '/zoho/v1/invoices', payload);
  
    }
    getHistory(){
      let garageKey= localStorage.getItem('garageKey');

      return this.http.get(`${GlobalVariable.BASE_API_URL_SPARES}` + '/zoho/v1/customer/payments/'+ garageKey);
    }
createPaymentLink(
  selectedInvoices: any[],
  isAutoversePay: boolean,
  multipleInvoice: boolean,
  isAdvancePayment: boolean
) {
  const amount = selectedInvoices.reduce((total, inv) => total + inv.balance, 0);

  let invoices: any[] = [];

  if (!isAutoversePay) {
    invoices = selectedInvoices.map(inv => ({
      amount: inv.balance,
      invoiceId: inv.invoiceId,
      invoiceNumber: inv.invoiceNumber
    }));
  }

  const invoiceNumbers = isAutoversePay
    ? (selectedInvoices[0]?.invoiceNumber || [])
    : invoices.map(i => i.invoiceNumber).join(', ');

  // Ensure mutual exclusivity
  let finalIsAdvancePayment = isAdvancePayment;
  let finalIsAutoversePay = !isAdvancePayment;
  if(multipleInvoice==true){
    finalIsAdvancePayment = false;
    finalIsAutoversePay = false;
  }

  const payload = {
    amount: amount.toFixed(2),
    contactName: localStorage.getItem('contactName'),
    garageKey: localStorage.getItem('garageKey'),
    invoices: invoices,
    isAdvancePayment: finalIsAdvancePayment || false,
    isAutoversePay: finalIsAutoversePay || false,
    mobileNumber: localStorage.getItem('contactPhone'),
    multipleInvoicePayment: multipleInvoice,
    paymentFor: `${invoiceNumbers}`,
    userId: localStorage.getItem('spareUserKey'),
    source: 'web'
  };


  // console.log('PAYMENT PAYLOAD', payload);

  return this.http.post(`${GlobalVariable.BASE_API_URL_SPARES}/payment/link/create`, payload);
}



getCreditNotes() {
  const payload = {  
    garageKey: localStorage.getItem('garageKey')
  };

  return this.http.post(`${GlobalVariable.BASE_API_URL_SPARES}/creditnote/getAll/creditNotes/`, payload);
}
  createCreditNoteUrl(creditNoteId: string, creditNoteNumber: string) {
    const payload = {
      creditNoteId,
      creditNoteNumber
    };
    return this.http.post<any>(`${GlobalVariable.BASE_API_URL_SPARES}/creditnote/create/creditNoteUrl`, payload);
  }

}